import Logo from '../../components/logo'

function GenericError ({ error, errorMessage, children }) {
  return (
    <main className='container mx-auto'>
      <div className='mt-[220px] px-48'>
        <Logo flipped className='h-6' />
        {error !== 'change-portal-url' && (
          <h2 className='text font-medium mt-8 text-white'>
            {errorMessage}
          </h2>
        )}
        {children}
      </div>
    </main>
  )
}

export default GenericError
